/**
 * FeaturedCarousel - featured content carousel section built on the slider.
 * Custom element: <featured-carousel>
 *
 * Attributes (from $info):
 *   is-tabbed  Boolean  -
 *
 * Refs:
 *   [data-ref="sectionHeader"]  (optional)
 *   [data-ref="tab1Slides"]  (optional)
 *   [data-ref="tab2Slides"]  (optional)
 *   [data-ref="tab3Slides"]  (optional)
 *   [data-ref="slider"]  (optional)
 *   [data-ref="mobileCta"]  (optional)
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import "./component-SectionHeader.js";
import "./component-ThemeCarousel.js";
import { ThemeComponent } from "./theme.js";
import "./component-SectionHeaderTabs.js";
import "./component-ProductOptionPicker.js";
import "./component-ProductButtonOption.js";
import "./vendor.js";
import "./component-ProductDropdownOption.js";
import "./component-FakeDropdown.js";
class FeaturedCarousel extends ThemeComponent {
  init() {
    this.slider && this.addListeners();
  }
  addListeners() {
    const swiperWrapper = this.slider.querySelector(".swiper-wrapper");
    if (swiperWrapper && this.isTabbed) {
      const tab1 = this.sectionHeader.sectionHeaderTabs.tab1,
        tab2 = this.sectionHeader.sectionHeaderTabs.tab2,
        tab3 = this.sectionHeader.sectionHeaderTabs.tab3;
      tab1 && this.$listen(tab1, "click", clickEvent => {
        this.setSlideWidth(), this.buttonActive(tab1), this.buttonNotActive(tab2), this.buttonNotActive(tab3), swiperWrapper.innerHTML = this.tab1Slides.innerHTML, this.slider.manualUpdate(), this.handleCTA(this.tab1Slides);
      }), tab2 && this.$listen(tab2, "click", clickEvent => {
        this.setSlideWidth(), this.buttonActive(tab2), this.buttonNotActive(tab1), this.buttonNotActive(tab3), swiperWrapper.innerHTML = this.tab2Slides.innerHTML, this.slider.manualUpdate(), this.handleCTA(this.tab2Slides);
      }), tab3 && this.$listen(tab3, "click", clickEvent => {
        this.setSlideWidth(), this.buttonActive(tab3), this.buttonNotActive(tab2), this.buttonNotActive(tab1), swiperWrapper.innerHTML = this.tab3Slides.innerHTML, this.slider.manualUpdate(), this.handleCTA(this.tab3Slides);
      });
    }
  }
  buttonActive(button) {
    button && button.classList.add("is-active");
  }
  buttonNotActive(button) {
    button && button.classList.remove("is-active");
  }
  setSlideWidth() {
    const slideWidth = this.slider.querySelector(".swiper-slide").offsetWidth;
    this.style.setProperty("--slideWidth", `${slideWidth}px`);
  }
  handleCTA(activeSlides) {
    var ctaParentForHide, mobileCtaForHide, ctaParentForShow, mobileCtaForShow;
    if (!this.sectionHeader.cta || !this.mobileCta) return;
    const ctaLink = activeSlides.dataset.link,
      ctaLabel = activeSlides.dataset.cta;
    if (ctaLink == "" || ctaLabel == "") {
      (ctaParentForHide = this.sectionHeader.cta.parentElement) == null || ctaParentForHide.classList.add("hidden"), (mobileCtaForHide = this.mobileCta) == null || mobileCtaForHide.classList.add("hidden");
      return;
    }
    (ctaParentForShow = this.sectionHeader.cta.parentElement) == null || ctaParentForShow.classList.remove("hidden"), this.sectionHeader.cta.href = ctaLink, this.sectionHeader.cta.innerHTML = ctaLabel, (mobileCtaForShow = this.mobileCta) == null || mobileCtaForShow.classList.remove("hidden"), this.mobileCta.href = ctaLink, this.mobileCta.innerHTML = ctaLabel;
  }
}
setFunctionName(FeaturedCarousel, "FeaturedCarousel");
const propertyTypes = {
  Boolean
};
FeaturedCarousel.prototype.$name = "FeaturedCarousel";
FeaturedCarousel.prototype.$info = JSON.parse('{"name":"FeaturedCarousel","meta":{"isLegacy":false,"selector":"featured-carousel"},"props":[{"attr":"is-tabbed","reflectAttr":false,"propertyKey":"isTabbed","propertyType":"Boolean","propertyTypeName":"Boolean","propertyTsTypeName":"boolean"}],"refs":[{"selector":"[data-ref=\\"sectionHeader\\"]","required":false,"propertyKey":"sectionHeader","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"SectionHeader"},{"selector":"[data-ref=\\"tab1Slides\\"]","required":false,"propertyKey":"tab1Slides","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"HTMLElement"},{"selector":"[data-ref=\\"tab2Slides\\"]","required":false,"propertyKey":"tab2Slides","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"HTMLElement"},{"selector":"[data-ref=\\"tab3Slides\\"]","required":false,"propertyKey":"tab3Slides","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"HTMLElement"},{"selector":"[data-ref=\\"slider\\"]","required":false,"propertyKey":"slider","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"Carousel"},{"selector":"[data-ref=\\"mobileCta\\"]","required":false,"propertyKey":"mobileCta","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"HTMLAnchorElement"}]}');
FeaturedCarousel.prototype.$info.component = FeaturedCarousel;
for (const prop of FeaturedCarousel.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("FeaturedCarousel/FeaturedCarousel.ts", {
  FeaturedCarousel: FeaturedCarousel
}, void 0);